import { ActionTree, ActionContext } from 'vuex';
import AuthService from '../services/AuthService';
import { LoginPayload, RefreshTokenReponse } from '../types';
import jwtDecode from 'jwt-decode';

import {
    LOGIN,
    LOGIN_SUCCESS,
    LOGIN_ERROR,
    LOGOUT,
    REFRESH_TOKEN,
    REFRESH_TOKEN_SUCCESS,
    REFRESH_TOKEN_ERROR,
    ME,
    ME_SUCCESS,
    ME_ERROR,
    FETCH_ACCOUNT,
    FETCH_ACCOUNT_SUCCESS,
    FETCH_ACCOUNT_ERROR,
} from './constants';
import { AuthState } from '../types';
import { LoginReponse, MeResponse } from '@/modules/auth/types';

const auth = new AuthService();

const actions = {
    async [ME](store: ActionContext<AuthState, any>) {
        try {
            const token = localStorage.getItem('token');
            const ref = jwtDecode(token);
            // const response: MeResponse = await auth.me(ref);
            store.commit(ME_SUCCESS, ref);
        } catch (e) {
            store.commit(ME_ERROR);
        }
    },
    async [LOGIN](store: ActionContext<AuthState, any>, data: LoginPayload) {
        store.commit(LOGIN);
        try {
            const response: LoginReponse = await auth.login(data);
            if (response.token && response.refresh_token) {
                localStorage.setItem('token', response.token);
                localStorage.setItem('refresh_token', response.refresh_token);
                await store.dispatch(ME);
                store.commit(LOGIN_SUCCESS, response);
            } else {
                store.commit(LOGIN_ERROR);
            }
        } catch (e) {
            store.commit(LOGIN_ERROR);
        }
    },
    async [FETCH_ACCOUNT](store: ActionContext<AuthState, any>, username: string) {
        store.commit(LOGIN);
        try {
            const response: any = await auth.fetchUser(username);
            store.commit(FETCH_ACCOUNT_SUCCESS, response);
        } catch (e) {
            store.commit(FETCH_ACCOUNT_ERROR);
        }
    },
    async [REFRESH_TOKEN](store: ActionContext<AuthState, any>, data: any) {
        try {
            localStorage.setItem('token', data.token);
            localStorage.setItem('refresh_token', data.refresh_token);
            store.commit(REFRESH_TOKEN_SUCCESS, data);
        } catch (e) {
            localStorage.removeItem('token');
            localStorage.removeItem('refresh_token');
            store.commit(REFRESH_TOKEN_ERROR);
        }
    },
    [LOGOUT](store: ActionContext<AuthState, any>, id: number) {
        localStorage.removeItem('token');
        store.commit(LOGOUT, id);
    },
} as ActionTree<AuthState, any>;

export default actions;
